const GenericEngine = require('GenericEngine');
const PSEvents = require('PSEvents');
const PSState = require('PSState');
const AudioMap = require('AudioMap');
const AudioManager = require('AudioManager');
const PSConfig = require('PSConfig');
const SlotUI = require('SlotUI');
const LaunchParamBuilder = require('./LaunchParamBuilder');

cc.Class({
    extends: cc.Component,

    properties: {
        nextSceneName: 'GameScene',
        assetsEnginLoadRatioCoefficient: 0.8,
        preloadInfoLabel: cc.Label,
        gamblingCommissionLogo: cc.Node,
        // uses cc.sys.os to check if low audio will be used, look in CCSys.js  for possible OS string names
        lowAudioSupportOS: cc.String
    },

    // Total 100% Loading is divided into 70% responsible for assets loading, and 30% responsible for CGK init
    onLoad() {
        this.connectionProgress = 0;
        this.assetsProgress = 0;
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        if (this.preloadInfoLabel) {
            this.preloadInfoLabel.string = '';
        }

        if (this.gamblingCommissionLogo) {
            this.gamblingCommissionLogo.active = false;
        }
    },

    onDestroy() {
        PSEvents.unsubscribe(PSEvents.COMMON_INITIALIZED, this.commonInitializedHandler);
    },

    /**
     * Start the loading of the game and initialisation of the engine.
     * Use this.node.on('progress', progress) to listen progress event  progress - value between 0.0 ~ 1.0
     * Use this.node.on('loadingComplete', settings) to listen loading complete event and get settings data
     */
    startLoading(loadConfiguration)
    {
        LaunchParamBuilder.build(loadConfiguration);

        if (window.PSGames && window.PSGames.CommonAPI) {
            this._startLoading();
        } else {
            this._loadEngineScripts(loadConfiguration);
        }
    },

    _loadEngineScripts (loadConfiguration) {
        const engineWrapper = document.createElement('script');
        engineWrapper.onload = () => {
            const gameExtension = document.createElement('script');
            gameExtension.onload = () => {
                this._startLoading();
            };
            gameExtension.src = loadConfiguration.gameExtensionURL;
            document.head.appendChild(gameExtension);
        };
        engineWrapper.src = loadConfiguration.engineWrapperURL;

        document.head.appendChild(engineWrapper);
    },

    _startLoading () {
        GenericEngine.initEngine();
        const initEnginePromise = new Promise((resolve) => {
            const callback = (data) => {
                this.connectionProgress = 1;
                this._onProgress();
                this.settings = data;
                cc.log('Engine initialised.');

                this._preloadInfoMessage().then(resolve);
                // resolve();
            }
            if (GenericEngine.isInitialized()) {
                callback(PSState.get());
            } else {
                this.commonInitializedHandler = (data) => {
                    callback(data);
                };
                PSEvents.subscribe(PSEvents.COMMON_INITIALIZED, this.commonInitializedHandler)
            }
        });

        const loadingPromise = new Promise((resolve) => {
            cc.director.preloadScene(this.nextSceneName,
                (progress, total) => {
                    // during the progress the {progress} and {total} parameters are changed
                    // so added math.max for consistent growth
                    this.assetsProgress = Math.max(progress / (total), this.assetsProgress);
                    if(window.PSGames.events.handler) {
                        window.PSGames.events.handler('loadingProgress', { percent: this.assetsProgress });
                    }
                    this._onProgress();
                },
                () => {
                    resolve();
                });
        });

        const audioPath = this.useLowAudio() ? 'audioSprite/low/audio' : 'audioSprite/audio' ;
        const audioSpritePromise = new Promise((resolve) => {
            cc.resources.loadDir(audioPath, (err, assets) => {
                if (err) {
                    throw new Error(err);
                }

                let audiosprite, json;

                assets.forEach(a => {
                    if (a instanceof cc.AudioClip) {
                        audiosprite = a;
                    }

                    if (a instanceof cc.JsonAsset) {
                        json = a.json;
                    }
                });


                this.audioManager.preloadAudio(
                    audiosprite,
                    json).then(() => {
                    this.node.emit('audioComplete');
                    resolve();
                });
            });
        });

        Promise.all([initEnginePromise, loadingPromise, audioSpritePromise]).then(() => {
            // Enable slow connection checking if needed.
            const { slowConnection } = PSConfig.get();

            if(slowConnection) {
                GenericEngine.checkSlowConnection(slowConnection);
            }

            PSEvents.publish(PSEvents.LOAD_END);
            // Emit Loading Complete and send the user menu settings data
            this.node.emit('loadingComplete', { settings: this.settings, sceneName: this.nextSceneName });
        });
    },

    _preloadInfoMessage() {
        const info = SlotUI.getPreloaderInfo();

        if (!info || !info.hasMessage) {
            return Promise.resolve();
        } else {
            if (!this.preloadInfoLabel) {
                const scene = cc.director.getScene();
                const node = new cc.Node('PreloadInfoLabel');

                node.parent = scene;
                node.setPosition(0, 0);
                this.preloadInfoLabel = node.addComponent(cc.Label);
            }
            this.preloadInfoLabel.string = info.message;

            if (this.gamblingCommissionLogo) {
                this.gamblingCommissionLogo.active = true;
            } else {
                cc.warn('Missing gambling commission logo');
            }

            return new Promise(resolve => this.scheduleOnce(() => {
                if (this.preloadInfoLabel) {
                    this.preloadInfoLabel.string = '';
                }
                if (this.gamblingCommissionLogo) {
                    this.gamblingCommissionLogo.active = false;
                }
                resolve();
            }, info.delay));
        }
    },

    _onProgress()
    {
        const c1 = this.assetsEnginLoadRatioCoefficient;
        const c2 = 1 - this.assetsEnginLoadRatioCoefficient;
        const totalProgress = this.assetsProgress * c1 + this.connectionProgress * c2;

        this.node.emit('progress', totalProgress);
    },

    useLowAudio() {
        return  this.lowAudioSupportOS.split(',').includes(cc.sys.os);
    }
});
